<template>
<div class="row plain-element">
    <div v-if="!isLoggedIn()"  class="dashboard-cards">
        <NoPermissionComponent/>
    </div>
   <div v-if="getUsername() && getCorporatePlanData()" class="dashboard">
    <div class="row row-cards">
      <div class="row text-start row-back">
        <a class="back-link" @click="hasHistory() ? $router.go(-1): $router.push('/')">
          <span class="material-icons chevron-left">chevron_left</span> Back To Plan
        </a>
      </div>
    </div>
    <div   v-if="getCorporatePlanData().plan_manager === getUsername()" class="card card-details">
      <p class="error"  v-if="getFormError()">
        <span id="formError">{{ getFormError() }}</span>
      </p>
      <p class="error"  v-else>
      </p>
      <UpdateCorporatePlanRefLineComponent
              :id = id
              :current_name = getCorporatePlanData().name
              :current_company = getCorporatePlanData().company
              :current_description = getCorporatePlanData().description
              :current_currency = getCorporatePlanData().currency

              :current_macc_carbon_offsetting_cost = getCorporatePlanData().macc_carbon_offsetting_cost
              :current_macc_carbon_per_money = getCorporatePlanData().macc_carbon_per_money
      />
    </div>
  </div>
</div>
</template>


<script>

import { mapGetters, mapActions } from "vuex";
import { hasHistory } from "@/common/general.js";
import UpdateCorporatePlanRefLineComponent from "@/components/corporate_plans/UpdateCorporatePlanRefLineComponent.vue";
import NoPermissionComponent from "@/components/NoPermissionComponent.vue"

export default {
  name: "CorporatePlanRefLineUpdate",
  components: {
    UpdateCorporatePlanRefLineComponent,
    NoPermissionComponent,
  },
  props: {
    id: { type: String, required: true },
  },
  data() {
    return {

    }
  },
  methods: {
    ...mapGetters(["getCorporatePlanData","getFormError", "getUsername", "isLoggedIn"]),
    ...mapActions(["fetchCorporatePlanData", "performSetFormError"]),
    hasHistory: hasHistory,
    getPlanDetails() {
      this.fetchCorporatePlanData({"id": this.id })
    },
  },

  created() {
    this.getPlanDetails();
    this.performSetFormError(null);
    document.title = "Update Ref. Lines";
    window.scrollTo(0,0);
  },
  beforeRouteUpdate (to, from, next) {
    this.getPlanDetails();
    next();
  }
}


</script>
